/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_Free_TierInputs */

const en_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const es_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const de_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const ja_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const ar_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني`)
};

const id_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar`)
};

const it_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ru_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const pt_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ko_badge_free_tier = /** @type {(inputs: Badge_Free_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

/**
* | output |
* | --- |
* | "Base" |
*
* @param {Badge_Free_TierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_free_tier = /** @type {((inputs?: Badge_Free_TierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Free_TierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_free_tier(inputs)
	if (locale === "es") return es_badge_free_tier(inputs)
	if (locale === "fr") return fr_badge_free_tier(inputs)
	if (locale === "de") return de_badge_free_tier(inputs)
	if (locale === "ja") return ja_badge_free_tier(inputs)
	if (locale === "zh") return zh_badge_free_tier(inputs)
	if (locale === "ar") return ar_badge_free_tier(inputs)
	if (locale === "id") return id_badge_free_tier(inputs)
	if (locale === "it") return it_badge_free_tier(inputs)
	if (locale === "ru") return ru_badge_free_tier(inputs)
	if (locale === "pt") return pt_badge_free_tier(inputs)
	return ko_badge_free_tier(inputs)
});